import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import TimetableSyncDashboard from "./routes/TimetableSyncDashboard";
import PeriodsMapping from "./routes/PeriodsMapping";
import GradeStructureMapping from "./routes/GradesStructureMapping";

export default store => ({
  path: ":curriculum_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-timetableSync" */ "./components"),
        import(
          /* webpackChunkName: "admin-timetableSync" */ "./modules/TimetableSyncSetupModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "Integrations/modules/IntegrationsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        const reducer = module.default;
        const key = module.NAME;
        const integrationsModuleKey = importedModule2.NAME;
        const integrationsModuleReducer = importedModule2.default;

        injectReducer(store, {
          key,
          reducer,
        });
        injectReducer(store, {
          key: integrationsModuleKey,
          reducer: integrationsModuleReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    TimetableSyncDashboard(store),
    PeriodsMapping(store),
    GradeStructureMapping(store),
  ],
});
